import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ShopComponent } from './sections/home-page/shop/shop.component';
import { ShopTableComponent } from './sections/home-page/home-table/shop-table.component';
import { AngularMaterialModule } from 'src/app/angular-material/angular-material.module';
import { ReviewCreateClinicOfficeDialogComponent } from './dialogs/review-create-clinic-office-dialog/review-create-clinic-office-dialog.component';
import { DeleteClinicOfficeDialogComponent } from './dialogs/delete-clinic-office-dialog/delete-clinic-office-dialog.component';
import { InfoClinicOfficeDialogComponent } from './dialogs/info-clinic-office-dialog/info-clinic-office-dialog.component';
import { CreateClinicOfficeDialogComponent } from './dialogs/create-clinic-office-dialog/create-clinic-office-dialog.component';
import { EditClinicOfficeDialogComponent } from './dialogs/edit-clinic-office-dialog/edit-clinic-office-dialog.component';
import { ReviewEditClinicOfficeDialogComponent } from './dialogs/review-edit-clinic-office-dialog/review-edit-clinic-office-dialog.component';
import { PublishClinicOfficeDialogComponent } from './dialogs/publish-clinic-office-dialog/publish-clinic-office-dialog.component';
import { MapDialogComponent } from './dialogs/map-dialog/map-dialog.component';
import { MapSelectionDialogComponent } from './dialogs/map-selection-dialog/map-selection-dialog.component';
import { GoogleMapsModule } from '@angular/google-maps';
import { ReactiveFormsModule } from '@angular/forms';
import { ExportCsvDialogComponent } from './dialogs/export-csv-dialog/export-csv-dialog.component';
import { HistoryLogDialogComponent } from './dialogs/history-log-dialog/history-log-dialog.component';
import { GenerateZipLookupTableDialogComponent } from './dialogs/generate-zip-lookup-table-dialog/generate-zip-lookup-table-dialog.component';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { ConvertCsvToJsonDialogComponent } from './dialogs/convert-csv-to-json-dialog/convert-csv-to-json-dialog.component';

export const MY_FORMATS = {
  parse: {
    dateInput: 'yyyy-MM-DD',
  },
  display: {
    dateInput: 'yyyy-MM-DD',
    monthYearLabel: 'yyyy',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'yyyy',
  },
};


@NgModule({
  declarations: [
    ShopComponent,
    ShopTableComponent,
    CreateClinicOfficeDialogComponent,
    ReviewCreateClinicOfficeDialogComponent,
    EditClinicOfficeDialogComponent,
    ReviewEditClinicOfficeDialogComponent,
    DeleteClinicOfficeDialogComponent,
    InfoClinicOfficeDialogComponent,
    PublishClinicOfficeDialogComponent,
    MapDialogComponent,
    MapSelectionDialogComponent,
    ExportCsvDialogComponent,
    HistoryLogDialogComponent,
    GenerateZipLookupTableDialogComponent,
    ConvertCsvToJsonDialogComponent,

  ],
  imports: [
    CommonModule,
    AngularMaterialModule,
    GoogleMapsModule,
    ReactiveFormsModule
  ],
  exports: [
    ShopComponent,
    ShopTableComponent
  ],
  providers: [{ provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS] },
  { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }]
})
export class ShopManagerModule { }
